
import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton, Button, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OtpBox from '../OtpBox';

const OtpModal = ({ isOpen, onClose, onVerify, loading, newEmail }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

  const handleVerifyOtp = () => {
    if (otp.length !== 6) {
      setError('Please enter a complete 6-digit OTP.');
    } else {
      setError('');
      onVerify(otp);
    }
  };

  const handleOtpChange = (value) => {
    setOtp(value);
    if (value.length === 6) {
      setError('');
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="otp-modal"
      aria-describedby="modal-to-enter-otp"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        borderRadius: '16px',
        p: 4,
        outline: 'none',
      }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}>
          <Typography id="otp-modal" variant="h6" component="h6" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
            Update Email Address
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ p: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem', textAlign: 'center' }}>
            Enter OTP received to your new Email
          </Typography>
          <Typography sx={{ mb: 3, fontSize: '0.875rem', textAlign: 'center', color: 'text.secondary', fontWeight: 500 }}>
            {newEmail}
          </Typography>
          <OtpBox length={6} handleSubmit={handleOtpChange} />
          {error && (
            <Typography sx={{ mt: 1, color: 'error.main', fontSize: '0.75rem', textAlign: 'center' }}>
              {error}
            </Typography>
          )}
        </Box>
        <Box sx={{display:'flex', flexDirection:'row', gap:'16px', }}>
          <Button
            variant="outlined"
            onClick={onClose}
            fullWidth
            sx={{
              color: "#010320",
              textTransform: 'none',
              alignContent:'center',
              border:'1px solid #E5E7EB',
              borderRadius:'12px',
              '&:hover': {
                bgcolor: 'transparent',
                textDecoration: 'underline',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleVerifyOtp}
            disabled={otp.length !== 6 || loading}
            fullWidth
            sx={{
              bgcolor: "#010320",
              color: "#FFF",
              alignContent:'center',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 16px',
              '&:hover': {
                bgcolor: "#010320",
              },
              '&.Mui-disabled': {
                bgcolor: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#FFF" }} />
            ) : (
              "Verify Now"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OtpModal;